export default "__VITE_ASSET__BWn5GQ7A__"